export const programAreaOptions = [
  'shared_attention',
  'shared_play',
  'independent_play',
  'drawing',
  'echoic',
  'writing_transcription',
  'flexibility_problem_solving',
  'self_care_autonomy',
  'group_routines',
  'leisure_recreation',
  'safety_skills',
  'functional_academic',
  'functional_calendar',
  'functional_shopping',
  'functional_cooking',
  'functional_household',
  'social_skills',
  'motor_imitation',
  'intraverbal',
  'reading_textual',
  'mand',
  'mathematics',
  'listener',
  'listener_feature_function_class',
  'matching_visual_perception',
  'pairing_prerequisites',
  'emotional_regulation',
  'tact',
  'theory_mind_inferences',
];
